import React, { useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import {
  useCreateOrderMutation,
  useCreateReservationMutation,
} from "../../Store/Apis/bookingApi";
import { useNavigate } from "react-router-dom";
import AddEditBooking from "../../Components/AddEditBooking/AddEditBooking";
import { resendBookingEmail } from "../../Store/Apis/ReservationApi";

const NewSale = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const user = useSelector((state) => state.auth.user);

  const [createOrder, createOrderResponse] = useCreateReservationMutation();

  const getCreatedOrderId = (response) => {
    const candidates = [
      response?.orderId,
      response?.orderID,
      response?.data?.orderId,
      response?.data?.orderID,
      response?.data?.id,
      response?.data?.Id,
      response?.data?.data?.[0]?.orderId,
      response?.data?.data?.[0]?.orderID,
      response?.data?.data?.[0]?.id,
      response?.data?.data?.[0]?.Id,
    ];

    return candidates.find(
      (value) => value !== undefined && value !== null && value !== "",
    );
  };

  const handlePlaceOrder = async (orderData, options = {}) => {
    if (isSubmitting) return; // block duplicate clicks
    setIsSubmitting(true);
    try {
      const res = await createOrder(orderData);
      const responseData = res?.data || res;

      if (responseData?.status === 200) {
        const orderId = getCreatedOrderId(responseData);

        if (options?.sendResendAfterSave && options?.resendDocument) {
          const resendResult = await resendBookingEmail({
            outletId:
              orderData?.outletId || user?.outletID || user?.outletId || 0,
            orderId,
          });

          if (resendResult?.success) {
            toast.success(
              resendResult?.message || "Resend request sent successfully.",
              { duration: 4000 },
            );
          } else {
            toast.error(resendResult?.message || "Failed to resend document.", {
              duration: 7000,
            });
          }
        }

        toast.success(responseData?.message || "Booking created successfully", {
          duration: 7000,
        });
        navigate("/sales-history");
        return responseData;
      }

      toast.error(responseData?.message || "Booking failed", {
        duration: 7000,
      });
      return responseData;
    } catch (err) {
      console.log(err);
      toast.error("Something Went Wrong !!", { duration: 7000 });
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <AddEditBooking onSubmit={handlePlaceOrder} isSubmitting={isSubmitting} />
    </div>
  );
};

export default NewSale;
